import { createCategoryHandler } from "../category-dispatcher";
import { historyTools } from "./history-tools";

/**
 * Category handler for undo/redo history operations.
 * Consolidates history-tools sync handlers.
 */
export const handleHistoryCategory = createCategoryHandler({
  undo: historyTools.sync!.ui_common_undo,
  redo: historyTools.sync!.ui_common_redo
});
